export default __webpack_public_path__ + "static/media/aibot2.cd1b654a.png";